<div class="mx-auto px-4">
  <button type="button" (click)="goBack()" class="btn-secondary-novo mb-4">
    {{ 'INDEX_FORMATION.RETOUR' | translate }}
  </button>

  @if (isLoading) {
    <div class="flex justify-center items-center h-64">
      <mat-spinner color="accent"></mat-spinner>
    </div>
  }

  @if (!isLoading && (quizViewerUrl || quizSolutionaryUrl)) {
    <div class="mb-4 p-4 rounded-lg border border-gray-300 dark:border-gray-600 dark:bg-gray-800">
      <h2 class="text-base font-semibold mb-3 dark:text-white">
        {{ 'INDEX_FORMATION.QUIZ_SECTION' | translate }}
      </h2>
      <div class="flex flex-wrap gap-3">
        @if (quizViewerUrl) {
          <button type="button" (click)="openQuizDocument(quizViewerUrl)"
            class="btn-secondary-novo flex items-center gap-2"
            [matTooltip]="'INDEX_FORMATION.OPEN_FOR_PRINT' | translate">
            <mat-icon>quiz</mat-icon>
            <span>{{ 'INDEX_FORMATION.QUIZ_VIEWER_URL' | translate }}</span>
            <mat-icon class="text-sm">print</mat-icon>
          </button>
        }
        @if (quizSolutionaryUrl) {
          <button type="button" (click)="openQuizDocument(quizSolutionaryUrl)"
            class="btn-secondary-novo flex items-center gap-2"
            [matTooltip]="'INDEX_FORMATION.OPEN_FOR_PRINT' | translate">
            <mat-icon>fact_check</mat-icon>
            <span>{{ 'INDEX_FORMATION.QUIZ_SOLUTIONARY_URL' | translate }}</span>
            <mat-icon class="text-sm">print</mat-icon>
          </button>
        }
      </div>
      <p class="text-xs text-gray-600 dark:text-gray-300 mt-2">
        {{ 'INDEX_FORMATION.PRINT_HINT' | translate }}
      </p>
    </div>
  }

  @if (!isLoading && detail.length) {
    <div>
      <table mat-table [dataSource]="detail" class="mat-table-novo w-full">
        <ng-container matColumnDef="property">
          <th mat-header-cell *matHeaderCellDef class="table-cell px-4 py-2 dark:bg-gray-800 dark:text-white">
            {{ 'INDEX_FORMATION.PROPRIETE' | translate }}
          </th>
          <td mat-cell *matCellDef="let element" class="table-cell px-4 py-2 border-b dark:bg-gray-900 dark:text-white">
            {{ element.propertyKey | translate }}
          </td>
        </ng-container>
        <ng-container matColumnDef="value">
          <th mat-header-cell *matHeaderCellDef class="table-cell px-4 py-2 dark:bg-gray-800 dark:text-white">
            {{ 'INDEX_FORMATION.VALEUR' | translate }}
          </th>
          <td mat-cell *matCellDef="let element" class="table-cell px-4 py-2 border-b dark:bg-gray-900 dark:text-white">
            @if (element.propertyKey?.toLowerCase().includes('description')) {
              <span [innerHTML]="element.value"></span>
            } @else {
              @if (element.isImage) {
                <img [src]="element.value" alt="Thumbnail" class="max-h-64 rounded shadow" />
              }
              @if (element.isUrl && element.value !== '-' && !element.isImage) {
                <a [href]="element.value" download target="_blank"
                  class="text-blue-600 underline hover:text-blue-800">
                  @if (element.propertyKey === 'INDEX_FORMATION.QUIZ_VIEWER_URL' || element.propertyKey === 'INDEX_FORMATION.QUIZ_SOLUTIONARY_URL') {
                    {{ element.propertyKey | translate }}
                  } @else {
                    {{element.fileName}}
                  }
                </a>
              }
              @if (element.isReferences) {
                <ul class="list-disc pl-5">
                  @for (ref of element.value; track ref) {
                    <li>
                      <a [href]="ref" target="_blank" rel="noopener" class="text-blue-600 underline hover:text-blue-800">
                        {{ ref.split('/').pop() || ref }}
                      </a>
                    </li>
                  }
                </ul>
              }
              @if ((!element.isUrl || element.value === '-') && !element.isImage && !element.isReferences) {
                {{element.value}}
              }
            }
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
  }
</div>